import React, {memo, useCallback, useState} from 'react';
import './index.scss';
import iconStart from '../../assets/images/icons/scenario/play.png';
import iconStop from '../../assets/images/icons/scenario/pause.png';
import iconEdit from '../../assets/images/icons/scenario/scenario-edit.png';
import iconDelete from '../../assets/images/icons/scenario/clear-2.png';

import {toggleScenarioPopupScreenAction, toggleScenarioScreenAction} from '../../store/ui/actions';
import {useRPC} from '../../hooks/rpc';
import {useOutsideDetector} from '../../hooks/outside-detector';
import {useDispatch, useSelector} from 'react-redux';
import {onClickHandler} from '../../utils/onclick';
import {useQuestion} from '../../hooks/question';
import {useRelations} from '../../hooks/relations';
import {useLocalization} from "../../hooks/localization";

export const ScenarioPopupScreen = memo(function ScenarioPopupScreen() {
    const {t} = useLocalization();
    const dispatch = useDispatch();
    const visible = useSelector(state => state.ui.scenarioPopupScreen.visible);
    const selectedScenario = useSelector(state => state.ui.scenarioPopupScreen.selectedScenario);

    const question = useQuestion();
    const getRelations = useRelations();
    const [isDeleting, setDeleting] = useState(false);
    const [rpc] = useRPC();
    const centerAreaRef = useOutsideDetector(!isDeleting, () => {
        dispatch(toggleScenarioPopupScreenAction(null));
    });

    const play = useCallback(() => {
        if (selectedScenario.is_playing) {
            rpc.stopScenario();
        } else {
            rpc.playScenario(selectedScenario.id);
        }
        dispatch(toggleScenarioPopupScreenAction(null));
    }, [selectedScenario, rpc, dispatch]);

    const edit = useCallback(() => {
        dispatch(toggleScenarioScreenAction(selectedScenario));
        dispatch(toggleScenarioPopupScreenAction(null));
    }, [selectedScenario, dispatch]);

    const deleteSelected = useCallback(() => {
        return rpc.deleteScenario(selectedScenario.id)
            .finally(() => {
                dispatch(toggleScenarioPopupScreenAction(null));
            });
    }, [selectedScenario, rpc, dispatch]);

    const deletePressed = useCallback(() => {
        setDeleting(true);
        getRelations(selectedScenario.id, 'scenario')
            .then(([message, positiveButton]) => {
                const questionMessage = message == null ?
                    t('SCENARIO_WILL_BE_DELETED__CONFIRM',{name:selectedScenario.name.toUpperCase()}) :
                    t('SCENARIO_WILL_BE_DELETED_WITH_MESSAGE__CONFIRM',{name:selectedScenario.name.toUpperCase(), message:message.toUpperCase()});
                question(questionMessage, () => {
                    return deleteSelected().finally(() => setDeleting(false));
                }, () => setDeleting(false), positiveButton);
            });
    }, [t, deleteSelected, question, selectedScenario, getRelations]);

    if (!visible) {
        return null;
    }

    return (
        <div className={'scenario-screen-wrapper'}>
            <div className="center-area" ref={centerAreaRef}>
                <span>{selectedScenario.name}</span>
                <div className="scenario-buttons">
                    <div className="scenario-button" {...onClickHandler(play)}>
                        <img src={selectedScenario.is_playing ? iconStop : iconStart} alt=''/>
                        {selectedScenario.is_playing ? t('STOP_2') : t('START')}
                    </div>
                    <div className="scenario-button" {...onClickHandler(edit)}>
                        <img src={iconEdit} alt=''/>
                        {t('EDIT')}
                    </div>
                    <div className="scenario-button" {...onClickHandler(deletePressed)}>
                        <img src={iconDelete} alt=''/>
                        {t('DELETE')}
                    </div>
                </div>
            </div>
        </div>
    );
});
